import { withForm } from '@/core/form/withForm';
import { SelectPosDevice as BaseSelectPosDevice } from '@/components/molecules/SelectPosDevice';

export const SelectPosDevice = withForm(BaseSelectPosDevice);
